if (!customElements.get('product-custom-request')) {
  customElements.define('product-custom-request', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-custom-request-open]');
      trigger.addEventListener('click', () => {
        const link = this.querySelector('[name="contact[Link produs]"]');
        if (link) { const url = new URL(location.href); url.searchParams.delete('custom_request'); url.hash = ''; link.value = url.href; }
        const variant = this.querySelector('[data-request-variant]');
        const picker = document.querySelector('variant-picker, variant-selects, variant-radios');
        if (variant && picker) variant.value = [...picker.querySelectorAll('select option:checked, input[type=radio]:checked')].map(el => el.value).join(' / ') || variant.value;
        dialog.showModal();
      });
      this.querySelector('[data-custom-request-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => trigger.focus());
      if (dialog.querySelector('[data-custom-request-success]')) { trigger.querySelector('span').textContent = 'Cerere trimisă'; }
      if (this.classList.contains('mor-quote-request') && (window.morOpenQuoteRequest || new URLSearchParams(location.search).get('request_quote') === '1')) { dialog.showModal(); window.morOpenQuoteRequest = false; }
      if (new URLSearchParams(location.search).get('custom_request') === '1' && dialog.querySelector('[data-custom-request-result]')) dialog.showModal();
    }
  });
}
